<template>

    <!-- <section id="banner" class="wow animate__animated animate__bounceInUp d-flex justify-content-start align-items-center"> -->
    <section id="banner" class="d-flex justify-content-start align-items-center" style="padding: 0 25px">
        <b-container>
            <b-row container>
                <b-col cols="12" lg="6">
                    <span><img src="../../assets/page/banner/rectangle.png" alt="Ícone de um pequeno retangulo azul">Especialistas em Logística</span>
                    <h1>Sua carga, nossa </h1>
                    <h1>responsabilidade. </h1>
                    <h1>Sua confiança, </h1>
                    <h1>nosso compromisso.</h1>
                    <p>A Frazatto Logística é sua parceira estratégica com soluções completas para o transporte de commodities agrícolas, impulsionando o agronegócio brasileiro.</p>
                    <b-btn class="btn-standard"  @click="() => handleNavClick('services')">Conheça nossos serviços</b-btn>
                </b-col>
            </b-row>
        </b-container>
    </section>

</template>

<script>
import { scrollToSection } from '@/services/utils';

    export default {

        methods: {
            handleNavClick(id) {
                scrollToSection(id);
                this.selectedNavItem = id;
            }
        },

    }

</script>

<style scoped lang="scss">

    #banner {
        background-image: 
            linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0)),
            url('../../assets/page/banner/background.webp');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        width: 100dvw;
        min-height: 100vh;
        box-sizing: border-box;
        color: var(--white);

        span {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: .2rem;
            padding: .5rem 0;
        }

        h1 {
            font-weight: 500;
            padding: 0;
            margin: 0;
        }

        p {
            font-weight: 200;
            padding: .5rem 0;
            max-width: 350px;
        }
    }

    @media screen and (max-width: 500px){
        #banner {
            text-align: center;
            background-image: 
            linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0)),
            url('../../assets/page/banner/background.webp');

            span {
                justify-content: center;
            }

            p{
                max-width: 100%;
            }

            h1 {
                font-size: 32px;
            }
        }
    }

</style>